import React from "react";
import { Box } from "@mui/material";
import { SectionHeading } from "../Common/Typography/AppTypography";

const ProductMetricsSingle = ({ reportTitle, imageURL }) => {
  return (
    <Box sx={{ p: 2 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          mb: 2,
        }}
      >
        <Box
          component="img"
          src={imageURL}
          alt={reportTitle}
          sx={{
            maxWidth: "100%",
            width: "auto",
            height: "auto",
          }}
        />
      </Box>
      <SectionHeading sx={{ textAlign: "center", m: 0 }}>
        {reportTitle}
      </SectionHeading>
    </Box>
  );
};

export default ProductMetricsSingle;